import React, { useState, useEffect } from 'react';
import './Sidebar.css';
import Logo from '../../assets/redsky.png';
import AttLogo from '../../assets/att-logo.png';
import NestleLogo from '../../assets/nestle-logo.png';
import CirrusInfoContext from '../CirrusInfoContext/CirrusInfoContext';

const Sidebar = () => {
    const infoObject = React.useContext(CirrusInfoContext);
    const cirrusSkins = infoObject['cirrus.ui.skins'];
    const [attSkin, setAttSkin] = useState(false);
    const [nestleSkin, setNestleSkin] = useState(false);

    useEffect(() => {
        if (cirrusSkins === 'att') {
            setAttSkin(true);
            setNestleSkin(false);
        } else if (cirrusSkins === 'nestle') {
            setAttSkin(false);
            setNestleSkin(true);
        }
    }, []);

    return (
        <div className={attSkin ? 'sidebar att-skin' : nestleSkin ? 'sidebar nestle-skin' : 'sidebar'}>
            <div className="top-wrapper">
                {attSkin ?
                    <img src={AttLogo} alt="ATT Logo"/>
                    :
                nestleSkin ?
                    <img src={NestleLogo} alt="Nestle Logo" />    
                    :                
                    <img src={Logo} alt="Redsky Technologies " />    
                }
            </div>
            {(attSkin || nestleSkin) &&
                <div className="bottom-wrapper">
                    <h3>Powered by</h3>
                    <img src={Logo} alt="Redsky Technologies " />
                </div>
            }
        </div>
    );
}

export default Sidebar;